import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { SocketProvider, ThemeProvider } from "./context/SocketContext";
import { RealtimeSyncProvider } from "./context/RealtimeSyncContext";
import Layout from "./components/Layout";
import Login from "./auth/Login";
import Signup from "./auth/Signup";
import VerifyEmail from './auth/VerifyEmail';
import ForgetPassword from "./auth/ForgetPassword";
import ResetPassword from "./auth/ResetPassword";
import VerifyQueries from "./auth/VerifyQueries";

import Invoice from "./pages/Account-Setting/Invoice/Invoice";
import Documents from "./pages/Documents/Documents";
import Help from "./pages/HelpGuide/Help";
import Dashboard from "./pages/Dashboard/Dashboard";
import Profile from "./pages/Account-Setting/Profile/Profile";
import USACompanyFormation from "./pages/USA-Company-Formation/USACompanyFormation"
import CFO from "./pages/CFO-Advisory/CFO";
import Registered from "./pages/Registered-Agent/RegisteredAgentPage";

import Bookkeeping from "./pages/Bookkeeping/Bookkeeping";
import TaxFiling from "./pages/Tax Filling/TaxFiling";
import AnnualReportService from "./pages/AnnualReportService/AnnualReportService";
import ReferAndEarn from "./pages/ReferAndEarn/ReferAndEarn";
import Meetings from "./pages/Meetings/Meetings";
import PrivateRoute from "./components/PrivateRoute";
import Pricing from "./pages/Pricing/Pricing";
import PaymentSuccess from './pages/Pricing/PaymentSuccess';
import PaymentHistory from './pages/Pricing/PaymentHistory';
import { ToastProvider } from "./components/ui/Toast";
import "./index.css";

function App() {
  return (
    <ThemeProvider>
      <SocketProvider>
        <RealtimeSyncProvider>
        <ToastProvider>
          <Router>
          <Routes>
            <Route path="/" element={<Navigate to="/login" />} />
            <Route path="/login" element={<Login />} />
            <Route path="/signup" element={<Signup />} />
            <Route path="/verify-email" element={<VerifyEmail />} />
            <Route path="/verify-queries" element={<VerifyQueries />} />
            <Route path="/forgetpassword" element={<ForgetPassword />} />
            <Route path="/reset-password/:token" element={<ResetPassword />} />

            <Route path="/" element={<Layout />}>
              <Route path="/dashboard" element={<PrivateRoute> <Dashboard /> </PrivateRoute>} />
              <Route path="/help" element={<PrivateRoute> <Help /> </PrivateRoute>} />
              <Route path="/invoice" element={<PrivateRoute> <Invoice /> </PrivateRoute>} />
              <Route path="/profile" element={<PrivateRoute> <Profile /> </PrivateRoute>} />
              <Route path="/documents" element={<PrivateRoute> <Documents /> </PrivateRoute>} />
              <Route path="/pricing" element={<PrivateRoute> <Pricing /> </PrivateRoute>} />
              <Route path="/payment-success" element={<PrivateRoute> <PaymentSuccess /> </PrivateRoute>} />
              <Route path="/payment-history" element={<PrivateRoute> <PaymentHistory /> </PrivateRoute>} />
              <Route path="/usa-company-formation" element={<PrivateRoute> <USACompanyFormation /> </PrivateRoute>} />
              <Route path="/cfo-advisory" element={<PrivateRoute> <CFO /> </PrivateRoute>} />
              <Route path="/registered-agent" element={<PrivateRoute> <Registered /> </PrivateRoute>} />

              <Route path="/bookkeeping" element={<PrivateRoute> <Bookkeeping /> </PrivateRoute>} />
              <Route path="/tax-filing" element={<PrivateRoute> <TaxFiling /> </PrivateRoute>} />
              <Route path="/annual-report" element={<PrivateRoute> <AnnualReportService /> </PrivateRoute>} />
              <Route path="/refer-and-earn" element={<PrivateRoute> <ReferAndEarn /> </PrivateRoute>} />
              <Route path="/meetings" element={<PrivateRoute> <Meetings /> </PrivateRoute>} />

            </Route>

          </Routes>
        </Router>
        </ToastProvider>
        </RealtimeSyncProvider>
      </SocketProvider>
    </ThemeProvider>
  );
}

export default App;